module.exports = __webpack_public_path__ + "img/Avatar_color.1bb3fe03.svg";